export default __webpack_public_path__ + "static/media/sub-team-logo-default.8d29414d.png";